module.exports = __webpack_public_path__ + "img/b9.3cb59cbf.jpg";